module.exports = __webpack_public_path__ + "img/next.4e34eb8f.svg";